module.exports = __webpack_public_path__ + "img/user.69bb0ec1.png";